// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2i9VV","actions":"styles_actions__S2foy","error":"styles_error__3ADTQ","message":"styles_message__2R7j9"};